if (!customElements.get('about-gymsets')) {
  customElements.define(
    'about-gymsets',
    class AboutGymsets extends HTMLElement {
      connectedCallback() {
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.initReveal();
        this.initSlideshow();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        document.removeEventListener('visibilitychange', this.onDocVisibility);
      }

      initReveal() {
        if (this.reduceMotion.matches || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.classList.add('gs-about-ready');

        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.revealObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
        );

        this.revealObserver.observe(this);
      }

      initSlideshow() {
        this.slides = Array.from(this.querySelectorAll('[data-bolt-slide]'));
        this.index = 0;

        if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.reduceMotion.matches) {
          return;
        }

        this.interval = Number(this.dataset.interval) || 5000;

        this.startAutoplay();

        const media = this.querySelector('.gs-about-v2__media');
        if (media) {
          media.addEventListener('mouseenter', () => this.stopAutoplay());
          media.addEventListener('mouseleave', () => this.startAutoplay());
          media.addEventListener('focusin', () => this.stopAutoplay());
          media.addEventListener('focusout', () => this.startAutoplay());
        }

        this.onDocVisibility = () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };
        document.addEventListener('visibilitychange', this.onDocVisibility);

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.startAutoplay();
              } else {
                this.stopAutoplay();
              }
            });
          },
          { threshold: 0 }
        );
        this.visibilityObserver.observe(this);

        this.reduceMotion.addEventListener('change', () => {
          if (this.reduceMotion.matches) this.stopAutoplay();
        });
      }

      startAutoplay() {
        if (this.timer || this.reduceMotion.matches) return;
        this.timer = setInterval(() => this.advance(), this.interval);
      }

      stopAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }

      advance() {
        const current = this.slides[this.index];
        const next = (this.index + 1) % this.slides.length;
        const nextSlide = this.slides[next];

        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');

        nextSlide.classList.add('is-active');
        nextSlide.removeAttribute('aria-hidden');

        this.index = next;
      }
    }
  );
}
